import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack, Button, Box, CircularProgress} from 'views/components';

import {Translate} from 'views/module';

import MessageFeedBox from './messages/MessageFeedBox';
import LogFeedBox from './logs/LogFeedBox';

{/* List of Caregiver messages and Logs associated with the Caregiver */}
const CorrespondanceFeed = (props) => {
  // Comments to display on caregiver

  const {
    caregiverRn,

    // props for MessageFeedBox
    caregiverMessages: messages,
    caregiverLogs,

    caregiverMessagesLoading,
    caregiverMessagesLastEvaluatedKey,

    caregiverLogsLastEvaluatedKey,
    caregiverLogsLoading,

    sortDir,
    corType,
    caregiverBackend,
  } = props;

  const loadMoreMessages = () => {
    if (caregiverMessagesLoading && !caregiverMessagesLoading) {
      caregiverBackend.load.loadMessages(caregiverRn, caregiverMessagesLoading);
    }
    if (caregiverLogsLastEvaluatedKey && !caregiverLogsLoading) {
      caregiverBackend.load.loadLogs(caregiverRn, caregiverLogsLastEvaluatedKey);
    }
  };

  const messagesToDisplayCaluclator = React.useCallback(() => {
    const messagesFilter = Object.values(messages)
        .filter((message) => {
          return corType[message.messageType];
        });

    let oldestMessage = null;
    if (caregiverMessagesLastEvaluatedKey) {
      oldestMessage = Object.values(messages)
          .reduce((oldest, item) => {
            return new Date(item.createdAt) < new Date(oldest.createdAt) ? item : oldest;
          });
    }

    const logsFilter = Object.values(caregiverLogs)
        .filter((log) => {
          if (corType['LOGS']) {
            // limit logs shows to the oldest message
            if (oldestMessage && new Date(oldestMessage.createdAt) > new Date(log.createdAt) ) {
              return false;
            }

            return true;
          }
        });

    const messagesAndlogs = [
      ...(messagesFilter.map((e) => {
        return {...e, type: 'MESSAGE'};
      })),
      ...(logsFilter.map((e) => {
        return {...e, type: 'LOGS'};
      })),
    ];

    const sortedMessages = messagesAndlogs.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);

      if (sortDir === 'DESC') {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });

    return sortedMessages;
  }, [messages, caregiverLogs, sortDir, corType]);

  const messagesToDisplay = messagesToDisplayCaluclator();

  const moreMessages = caregiverMessagesLoading || caregiverLogsLoading;
  const showLoadMoreButton =
    (caregiverMessagesLastEvaluatedKey && !caregiverMessagesLoading) ||
    (caregiverLogsLastEvaluatedKey && !caregiverLogsLoading);

  return (
    <Grid container>
      <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 1 : 2}}>
        <Stack
          sx={{
            pt: 1,
            pb: 2,
          }}
        >
          {
            messagesToDisplay.map((message, index) => {
              if (message.type === 'MESSAGE') {
                return (
                  <Box
                    key={message.messageRn}
                  >
                    <MessageFeedBox
                      message={message}
                      caregiverBackend={caregiverBackend}
                    />
                  </Box>
                );
              } else if (message.type === 'LOGS') {
                return (
                  <Box
                    key={message.caregiverLogRn}
                  >
                    <LogFeedBox
                      log={message}
                      caregiverBackend={caregiverBackend}
                    />
                  </Box>
                );
              }
              return null;
            })
          }
        </Stack>
      </Grid>
      {
        moreMessages &&
          <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
            <CircularProgress/>
          </Grid>
      }
      {
        showLoadMoreButton &&
        <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            color={'primary'}
            onClick={loadMoreMessages}
          >
            <Translate expression={'caregiver.CaregiverDetail.Correspondance.Messages.LoadMore'} />
          </Button>
        </Grid>
      }
    </Grid>
  );
};
CorrespondanceFeed.propTypes = {
  caregiverRn: PropTypes.string.isRequired,

  // props for MessageFeedBox
  caregiverMessages: PropTypes.object.isRequired,
  caregiverLogs: PropTypes.object.isRequired,

  caregiverMessagesLoading: PropTypes.bool.isRequired,
  caregiverMessagesLastEvaluatedKey: PropTypes.string,

  caregiverLogsLoading: PropTypes.bool.isRequired,
  caregiverLogsLastEvaluatedKey: PropTypes.string,

  sortDir: PropTypes.string.isRequired,
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
  }).isRequired,

  caregiverBackend: PropTypes.object.isRequired,

};

export default React.memo(CorrespondanceFeed);
